import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";

//STYLES
import * as ControllerStyles from "../styles/controller";

//COMPONENTS
import GrowHeight from "./growHeight";
import GrowWidth from "./growWidth";
import ColorFade from "./colorFade";
import GrowMenu from "./growMenu";

function Controller() {
    function handleAnimateClick() {
        // if (animHeight == 120) {
        //     setAnimHeight(40);
        // } else {
        //     setAnimHeight(120);
        // }
    }

    return (
        <div style={ControllerStyles.body}>
            <Button onClick={handleAnimateClick}>Animate</Button>
            <br />
            <br />
            <Row>
                <Col style={ControllerStyles.columnPadding}>
                    <GrowHeight />
                </Col>
                <Col style={ControllerStyles.columnPadding}>
                    <GrowHeight style={{ backgroundColor: "blue" }} />
                </Col>
                <Col>
                    <GrowMenu />
                </Col>
                <Col></Col>
            </Row>
            {/* <GrowHeight /> */}
            <br />
            <br />
            <br />
            <Row>
                <Col>
                    <GrowWidth />
                </Col>
            </Row>
            <br />
            <br />
            <br />
            <Row>
                <Col>
                    <ColorFade />
                </Col>
                <Col>
                    <div style={ControllerStyles.boxShape}></div>
                </Col>
            </Row>
        </div>
    );
}

export default Controller;
